import { useContext, useRef } from "react";
import Swal from "sweetalert2";
import UserContext from "../../contexts/UserContext";
import _ from "lodash";

const SSOLoginCard = () => {
  const { goSSO } = useContext(UserContext);
  const emailRef = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();

    goSSO({ email: emailRef.current.value }, (data) => {
      if (data.success) {
        if (data.userData.isHR || data.userData.isAMT) {
          window.location.href = process.env.PUBLIC_URL + "/dashboard";
        } else if (data.userData.isBT || data.userData.isAdmin) {
          window.location.href =
            process.env.REACT_APP_ADMIN_URL +
            "/login?email=" +
            emailRef.current.value;
        }
      } else {
        Swal.fire({
          title: "Login Failed",
          text: data.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  };

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-6">
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded bg-gray-100 text-gray-700">
          <i className="fas fa-user-shield"></i>
        </span>
        <h3 className="text-lg font-bold text-gray-800">
          Marriott EID Users Login
        </h3>
      </div>
      {_.get(process.env, "REACT_APP_IS_LIVE", "false") === "false" && (
        <div>
          <form onSubmit={handleSubmit}>
            <p className="mb-4 text-sm leading-5 text-gray-600 bg-blue-50 p-1 rounded">
              Hotel Photography Lead, Login!
            </p>
            <div className="mb-6">
              <label className="mb-2 block text-sm font-bold text-gray-700">
                SSO Email
              </label>
              <input
                type="email"
                name="email"
                ref={emailRef}
                className="w-full rounded border px-3 py-2 text-gray-700 shadow focus:outline-none focus:shadow-outline"
                placeholder="Enter your Marriott EID"
              />
            </div>
            <button
              type="submit"
              className="btn w-full rounded px-4 py-2 font-bold text-white"
            >
              Sign in (Test) with Marriott EID
            </button>
          </form>

          <div className="text-center p-4">OR</div>
        </div>
      )}
      <button
        onClick={() =>
          (window.location.href = `${process.env.REACT_APP_API_URL}/frontend/auth/hotelrep-sso`)
        }
        className="btn text-white font-bold py-2 px-4 rounded w-full"
      >
        Marriott - SSO Login
      </button>
    </div>
  );
};

export default SSOLoginCard;
